module.exports = __webpack_public_path__ + "img/handraw_nouveauté.49af88d4.svg";